import WorkoutsHeader from './WorkoutsHeader';

export default WorkoutsHeader;
